export const SET_DYNAMIC_COMPONENT_DATA = 'SET_DYNAMIC_COMPONENT_DATA';

export const SET_DYNAMIC_COMPONENTS_DATA = 'SET_DYNAMIC_COMPONENTS_DATA';

export const RESET_DYNAMIC_COMPONENTS_DATA = 'RESET_DYNAMIC_COMPONENTS_DATA';
